const API_BASE = process.env.REACT_APP_API_URL || '/api';

// ─── Gestion token ────────────────────────────────────────────────────────────
export const getToken = () => localStorage.getItem('admin_token');
export const setToken = (token) => localStorage.setItem('admin_token', token);
export const removeToken = () => localStorage.removeItem('admin_token');

// ─── Requête de base ──────────────────────────────────────────────────────────
const request = async (endpoint, options = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers
  };

  const res = await fetch(`${API_BASE}${endpoint}`, { ...options, headers });

  if (res.status === 401 || res.status === 403) {
    removeToken();
    window.location.href = '/';
    return;
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erreur serveur');
  return data;
};

// ─── Auth ─────────────────────────────────────────────────────────────────────
export const login = (username, password) =>
  request('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password })
  });

export const verifyToken = () => request('/auth/verify');
export const logout = () => request('/auth/logout', { method: 'POST' });

// ─── Recherche ────────────────────────────────────────────────────────────────
export const search = (params) => {
  const qs = new URLSearchParams(params).toString();
  return request(`/search?${qs}`);
};

export const getReference = (ref) => request(`/search/reference/${ref}`);
export const getStats = () => request('/search/stats');

// ─── Fichiers ─────────────────────────────────────────────────────────────────
export const getFilePreviewUrl = (id) => `${API_BASE}/files/${id}/preview?token=${getToken()}`;
export const getFileDownloadUrl = (id) => `${API_BASE}/files/${id}/download?token=${getToken()}`;
